module.exports = __webpack_public_path__ + "img/youtube.6df7026.png";